module.exports = __webpack_public_path__ + "img/image_31.deed856b.png";